<template>
  <div
    class="base-widget"
    :style="{maxHeight}"
    v-on="hoverHandlers"
    @scroll="$emit('scroll', $event)"
  >
    <div
      class="d-flex align-items-center title-tabs"
      :style="{'min-height': (title)? '32px':'0'}"
    >
      <base-heading
        v-if="title"
        class="base-widget__head"
        :class="{'base-widget__head--has-right' :!!$slots.right}"
      >
        {{ title }}
      </base-heading>

      <slot
        name="right"
        :items="items"
      >
        <base-tabs
          v-if="items && items.length > 1"
          v-model="currentTab"
          :items="items"
        />
      </slot>
    </div>

    <base-card
      class="basecard"
      :condensed="condensed"
      :expanded="expanded"
      :medium="medium"
      :class="{
        'basecard--has-tabs': items && items.length > 0 ,
        'basecard--scrollable': scrollable,
        'basecard--show-scroll': isHover && scrollable || isIPad
      }"
    >
      <div
        v-if="hasHeading"
        class="heading"
        :class="{'heading--condensed': condensed}"
      >
        <slot name="heading" />
      </div>

      <slot name="after-heading" />

      <div
        class="base-widget__content"
        :class="{'base-widget__content--condensed': condensed}"
      >
        <slot
          v-if="!loading"
          :current="currentTab"
        />

        <template v-if="loading">
          <slot name="loading">
            <base-loading :show="loading" />
          </slot>
        </template>
      </div>

      <div
        v-if="hasFooter"
        class="footer"
        :class="{
          'apply-footer-bg': shouldApplyFooterBackground
        }"
      >
        <slot name="footer" />
      </div>
    </base-card>
  </div>
</template>

<script>
import Whichbrowser from '@/components/mixins/whichbrowser';
import Hoverable from '../mixins/hoverable';

export default {
  name: 'BaseWidget',
  mixins: [Hoverable, Whichbrowser],
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    condensed: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    initialTab: {
      type: Number,
      default: 0,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: String,
      default: '',
    },
    shouldApplyFooterBackground: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentTab: 0,
    };
  },
  computed: {
    hasHeading() {
      return this.$slots.heading;
    },
    hasFooter() {
      return this.$slots.footer;
    },
  },
  watch: {
    initialTab: {
      handler() {
        this.currentTab = this.initialTab;
      },
      immediate: true,
    },
    currentTab(val) {
      this.$emit('tabChanged', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.base-widget {
  margin-bottom: 0.8125rem;
  display: flex;
  flex-direction: column;
  min-width: 100%;

  &::v-deep .basecard {
    flex: 1;
  }

  &__head {
    margin-left: 0.25rem;
    margin-bottom: 0.5rem;
    min-height: 1.5rem;
    display: flex;
    align-items: center;
  }

  &__content{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  //Scrollbars style
  & *::-webkit-scrollbar {
    width: 1px;
  }
  & *::-webkit-scrollbar-corner {
    display: none;
  }
  & *{
    scrollbar-width: thin;
    scrollbar-color: white white;
  }
  & *::-webkit-scrollbar-track {
    background: white;
  }
  & *::-webkit-scrollbar-thumb {
    background-color: white;
    border-radius: 0;
    border: none;
  }
}

.basecard {
  min-height: 0; // This is required
  display: flex;
  flex-direction: column;

  &--has-tabs {
    border-radius: 5px 0 5px 5px;
  }

  &::v-deep > .card-body {
      display: flex;
      flex-direction: column;
  }

  &--scrollable {
    &::v-deep .card-body {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      // padding-right: 0.625rem;
    }

    .base-widget__content {
      flex-direction: column;
      // overflow: hidden;
      overflow-x: hidden;
      overflow-y: auto !important;
      padding-right: 11px;
      margin-right: -11px;
      &--condensed{
        margin-right: 0;
      }
    }
  }

  &--show-scroll{
    *::-webkit-scrollbar-thumb {
      background-color: #333333;
    }
    *::-webkit-scrollbar-track {
      background: #ECEBE8;
    }
    *{
      scrollbar-color: #333333 #ECEBE8;
    }
    // .base-widget__content{
      // overflow-y: auto !important;
      // padding-right: 10px;
    // }
  }
}

.heading {
  padding: 10px;
  background-color: $gray-light;
  margin-left: -1.25rem;
  margin-top: -1.25rem;
  margin-right: -1.25rem;
  &--condensed {
    margin-left: -0.625rem !important;
    margin-top: -0.625rem !important;
    margin-right: -0.625rem !important;
  }
}
.footer {
  padding: 10px;
  margin-left: -1.25rem;
  margin-bottom: -1.25rem;
  margin-right: -1.25rem;
  border-radius: 0 0 5px 5px;

   &.apply-footer-bg {
    background-color: $gray-light;
  }
}
.title-tabs{
  justify-content: end;
}
</style>
